<template>
		<div class="simple-modal-wrapper">
			<div @click="close()" class="close-modal">
					x
			</div>
			<slot>
			</slot>
		</div>
</template>

<script>
    export default {
        name: 'simple-modal',
		methods: {
			close() {
				this.$emit('close-modal');
			}
		},
        data() {
            return {

            };
        }
    }
</script>

<style lang="scss">
		.simple-modal-wrapper {
				background: rgb(255, 255, 255);
				position:fixed;
				top:0;
				left:0;
				z-index:1050;
				height:100%;
				width:100%;
				display:none;
				overflow-y:scroll;
		}

		.close-modal {
				position:absolute;
				top: 0;
				right:35px;
				color:#777;
				font-size: 50px;
				font-weight:bold;
				cursor:pointer;
				transition: 350ms ease all;
		}

		.close-modal:hover {
				color:#333;
		}

		.simple-modal-dialog {
				width:100%;
				max-width:1060px;
		}
</style>